import {
  MDMInformation as MDMInformationDto,
  SystemWithPolicyStatsResponseModel,
} from '@electricjs/mdm_management-client';

import {
  AppleDepServerTokenStateEnum,
  OrgSoftwareApp,
  ProvisionStatusEnum,
  SoftwareCatalogApp,
} from '@/types/mdmManagement';

export const mockProvisionStatus = ProvisionStatusEnum.COMPLETED_STATUS;

export const mockMdmInformation: MDMInformationDto = {
  mdm_organization_id: 'mdm-org-id-1',
  apple_certificate: {
    creator_apple_id: 'it-admin@example.com',
    serial_number: '0123456789ABCDEF',
    expires_at: '2027-06-01T00:00:00.000Z',
  },
  apple_mdm_dep_info: {
    dep_server_token_state: AppleDepServerTokenStateEnum.VALID,
    dep_access_token_expiry: '2027-06-01T00:00:00.000Z',
  },
};

export const mockRecoveryKey = 'ABCD-EFGH-IJKL-MNOP-QRST-UVWX';

export const mockSystemWithPolicyStats = (
  serialNumber: string
): SystemWithPolicyStatsResponseModel => ({
  system: {
    id: 'jc-system-id-1',
    active: true,
    hostname: 'C02ZK4W4LVDL-tommcgurl',
    display_name: 'C02ZK4W4LVDL-tommcgurl',
    os: 'Mac OS X',
    os_family: 'darwin',
    serial_number: serialNumber,
    last_contact: '2024-09-17T01:19:37.926Z',
  },
  policy_stats: {
    failed_policies: [],
    pending_policies: [],
    policy_count_data: { total: 5, success: 5, failed: 0, pending: 0 },
  },
});

export const mockSoftwareCatalogApps: SoftwareCatalogApp[] = [
  {
    software_app_id: 'catalog-app-slack-darwin',
    app_name: 'Slack',
    os_type: 'darwin',
    description: 'Team messaging',
    is_available: true,
  },
  {
    software_app_id: 'catalog-app-zoom-darwin',
    app_name: 'Zoom',
    os_type: 'darwin',
    description: 'Video meetings',
    is_available: true,
  },
  {
    software_app_id: 'catalog-app-slack-windows',
    app_name: 'Slack',
    os_type: 'windows',
    description: 'Team messaging',
    is_available: true,
  },
];

export const mockInitialOrgSoftwareApps: OrgSoftwareApp[] = [
  {
    software_app_id: 'catalog-app-zoom-darwin',
    app_name: 'Zoom',
    os_type: 'darwin',
    description: 'Video meetings',
  },
];
